import * as React from "react";
import {PlasmicPHeader} from "./plasmic/blank_website_mobile_first/PlasmicPHeader";
import {setLoginPage, setShowHistory, setShowMembership} from "../useAppPullState";
import DrawerCustom from "./Drawer";
import {useDrawer} from "../hooks/useDrawer";
import {useLogout} from "./hooks/useLogout";
import {syncWithServer} from "./actions/syncWithServer";
import {refreshPage} from "./MiniHeader";

const useDesktopLinks = () => {
    const {
        authUser, open,
        showHistory,
        showMembership,
    } = useDrawer();

    const logout = useLogout()

    return [
        {
            label: "Varaushistoria",
            onClick() {
                setShowHistory(!showHistory)
            }

        },
        {
            label: "Jäsenkortti",
            onClick() {
                setShowMembership(true)
            }

        },
        {
            label: authUser ? "Kirjaudu ulos" : "Kirjaudu sisään",
            onClick() {
                if (authUser) {
                    logout();
                    setLoginPage(true)
                }else{
                    setLoginPage(true)
                }

            }
        }

    ]
}
const useUI = () => {
    const {openMenu, open} = useDrawer();
    return {
        links: useDesktopLinks(),
        reload: {
            onClick: refreshPage,
        },
        logo: {
            onClick: () => window.location.reload(),
        },
        menuIcon: {
            onClick: open ? () => null : openMenu(true),
        },
        menu: {
            children: (
                <DrawerCustom/>
            )
        }
    }
}

const useProps = (props) => {
    return {
        ...props,
        ...useUI()
    }
}

function PHeader_(props, ref) {
    return <PlasmicPHeader root={{ref}} {...useProps(props)} />;
}

const PHeader = React.forwardRef(PHeader_);

export default PHeader;
